import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ allowedRole, children }) {
  const { user, role } = useAuth();

  // ❌ Pas connecté
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Mauvais rôle (supporte string ou array)
  if (allowedRole) {
    const allowed = Array.isArray(allowedRole) ? allowedRole : [allowedRole];
    if (!allowed.includes(role)) {
      return <Navigate to="/403" replace />;
    }
  }

  // ✅ Accès autorisé
  return children;
}
